import { Scrollable } from '@ztechapps/webui.util'
import React from 'react'
import { TableAndLoadMoreContent } from './TableAndLoadMoreContent'
import type { TableProps } from './index'
import styles from './table.module.scss'

export const ScrollableContent = (props: TableProps) => {
  const { height, responsive, scrollRef, scrollClassName, showThumb, ...rest } = props

  //if the height is number convert it to the vh
  let finalHeight = height
  if (typeof height === 'number') {
    finalHeight = height + 'vh'
  }

  return (
    <Scrollable
      ref={scrollRef}
      height={finalHeight as string}
      showThumb={showThumb}
      className={`${styles.fixedTableHeadFoot}  ${responsive ? 'table-responsive' : ''} ${scrollClassName ?? ''}`}
    >
      {/* `responsive` already applied to this Scrollable's className above — do not forward it,
          or TableContent (libs/webui/data-tools/src/Table/TableContent.tsx:54) wraps a second
          `.table-responsive` div inside it. */}
      <TableAndLoadMoreContent {...rest} />
    </Scrollable>
  )
}
